import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicySummary } from '../../actions/policy/reducePolicySummary';
import { reduceProductSettings } from '../../actions/policy/reduceProductSettings';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicySummarySaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicySummary', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());
        const response = yield call(fetch, `/api/policyTransaction/summary/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });
        const result = yield call([response, 'json']);
        // Only set operation if there's an error - don't overwrite successful operations from other sagas
        if (!result.operation.status) {
            yield put(reduceOperation({ ...result.operation, code: 'getPolicySummary' }));
            yield put(reduceLoading({ code: 'getPolicySummary', value: false }));
            return;
        }
        yield put(reducePolicySummary(result.policySummary));
        yield put(reduceProductSettings(result.productSettings));
        yield put(reduceLoading({ code: 'getPolicySummary', value: false }));
    } catch (error) {
        console.log('Error while calling Get Policy Summary API - ', error);
        yield put(reduceLoading({ code: 'getPolicySummary', value: false }));
    }
}
